(function (app) {

    app.constant("queueEntryStates",
        [
            { Label: "Waiting", Value: "Waiting" },
            { Label: "Pending", Value: "Pending" },
            { Label: "Approved", Value: "Approved" },
            { Label: "Declined", Value: "Rejected" },
            { Label: "Previous Rejection", Value: "PreviousRejectiong" }
        ]);
})(window.app);